// extracted by mini-css-extract-plugin
module.exports = {"detailsText":"LogsTableDetailsModal-detailsText-3iwn_ Scroller-scroller-26MBT"};